import { Action, combineReducers } from 'redux';

import { MetricsDataState } from '../state/MetricsDataState';
import { metricsDataReducer } from './MetricsDataReducer';
import { metricsRefreshListReducer } from './MetricsRefreshListReducer';

export const metricsReducer: (state: MetricsDataState, action: Action) => MetricsDataState = combineReducers<MetricsDataState>({
  dataPointsById: metricsDataReducer,
  metricRefreshList: metricsRefreshListReducer
});